import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import { BLUEFIG_VENDOR_URL } from "@/config";

/**
 * Static PWA entry point for ordering. This route deliberately redirects the
 * top-level browser window to BlueFig instead of using an iframe, preserving
 * first-party cookies and customer login sessions.
 */
export default function Order() {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      window.location.replace(BLUEFIG_VENDOR_URL);
    }, 450);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div
      className="fixed inset-0 grid place-items-center"
      style={{
        backgroundColor: "#0a3d1f",
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
      data-testid="order-page"
    >
      <div className="flex flex-col items-center gap-4 text-butter px-6" data-testid="order-loading">
        <img src="/brand_logo.png" alt="Brampton Cash & Carry" className="h-20 w-auto max-w-[82vw] rounded-lg object-contain bg-white p-3" />
        <Loader2 className="h-6 w-6 animate-spin" />
        <p className="text-sm font-medium">Opening your BlueFig ordering portal…</p>
        <a href={BLUEFIG_VENDOR_URL} data-testid="order-manual-portal-link" className="text-xs underline underline-offset-4 text-cream/80 hover:text-butter">
          Continue to BlueFig
        </a>
      </div>
      <noscript>
        <div style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", color: "#fff" }}>
          Please <a href={BLUEFIG_VENDOR_URL} style={{ textDecoration: "underline", marginLeft: 6 }}>continue to BlueFig</a>.
        </div>
      </noscript>
    </div>
  );
}
